import { instance } from "../libs/client";

/**
 * Nutrition Service
 * Communicates with the new nutrition calculation API
 */
class NutritionService {
  /**
   * Calculate nutrition needs based on pet profile
   * @param {Object} petProfile - Pet profile data
   * @returns {Promise} Nutrition calculation result with Fresh/Dry comparison
   */
  async calculateNutrition(petProfile) {
    const response = await instance.post("recommendation", petProfile);
    return response;
  }

  /**
   * Get product categories
   * @returns {Promise} Product categories list
   */
  async getCategories() {
    const response = await instance.get("nutrition/categories");
    return response;
  }
}

const nutritionService = new NutritionService();
export { nutritionService };
